module.exports = __webpack_public_path__ + "files/9caeb0126b47961826ec85470f2a06be.png";